import axios from 'axios'

import {
  COLLECTION_AVATAR_NAME,
  GAME_ACC,
  CIVILISATION_ID,
  CIVILISATION_LIST,
} from '../../app/constants'
import { JsonRpc } from 'eosjs'

export function RequestAvatar(user) {
  return axios.request({
    method: 'get',
    // baseURL: `https://wax.api.atomicassets.io/atomicassets/v1/assets?owner=${user}&collection_name=galaktikanft&page=1&limit=1000&order=desc&sort=asset_id`,
    baseURL: `https://test.wax.api.atomicassets.io/atomicassets/v1/assets?owner=${user}&collection_name=${COLLECTION_AVATAR_NAME}&page=1&limit=1000&order=desc&sort=asset_id&data.class=Avatar&nonce=${Date.now()}`,
  })
}

export function RequestStakedAvatar() {
  return axios.request({
    method: 'get',
    // baseURL: `https://wax.api.atomicassets.io/atomicassets/v1/assets?owner=${user}&collection_name=galaktikanft&page=1&limit=1000&order=desc&sort=asset_id`,
    baseURL: `https://test.wax.api.atomicassets.io/atomicassets/v1/assets?owner=gtestmainacc&collection_name=${COLLECTION_AVATAR_NAME}&page=1&limit=1000&order=desc&sort=asset_id&data.class=Avatar&nonce=${Date.now()}`,
  })
}
export async function RequestAvatarConfig() {
  const rpc = new JsonRpc('https://wax-testnet.eosphere.io')
  const data = await rpc?.get_table_rows({
    json: true,
    code: GAME_ACC,
    scope: GAME_ACC,
    table: 'avatarcfgs',
    limit: 15,
  })

  const filteredData = {}
  for (const civ of CIVILISATION_LIST) {
    if (civ === 'Galaktika') {
      continue
    }
    filteredData[civ] = data.rows.filter(
      (row) => row.civilization_id === CIVILISATION_ID[civ],
    )
  }
  console.log(filteredData, 'AVATAR TEMPLATES DATA')
  return filteredData
}
